import axios from 'apis';
import { sessionService } from 'redux-react-session';
import { getTowlotCatalogRoutine } from 'actions';
import {
  readTowlotCatalogCachedEnvelope,
  writeTowlotCatalogCacheFromResponse,
  clearTowlotCatalogCache,
  getTowlotCatalogFetchEpoch
} from 'helpers/towlotCatalogStorage';

export { clearTowlotCatalogCache };

let loadTowlotCatalogPromise = null;

const auctionBoundsComplete = (b) =>
  b != null &&
  Number.isFinite(b.min) &&
  Number.isFinite(b.max) &&
  Number.isFinite(b.default);

/**
 * Loads Towlot reference data once: sessionStorage → network (single in-flight), then Redux.
 */
export const getTowlotCatalog = () => (dispatch, getState) => {
  const tc = getState().towlotCatalog;
  if (tc.loaded && auctionBoundsComplete(tc.data?.suggestedDaysForAuction)) {
    return Promise.resolve();
  }

  if (!tc.loaded) {
    const envelope = readTowlotCatalogCachedEnvelope();
    if (envelope) {
      dispatch(getTowlotCatalogRoutine.success(envelope));
      return Promise.resolve();
    }
  }

  if (loadTowlotCatalogPromise) {
    return loadTowlotCatalogPromise;
  }

  dispatch(getTowlotCatalogRoutine.request());

  const epochAtFetchStart = getTowlotCatalogFetchEpoch();

  loadTowlotCatalogPromise = sessionService
    .loadSession()
    .then(({ token: access_token }) =>
      axios.get('/user/towlot_catalog', { params: { access_token } })
    )
    .then((res) => {
      if (getTowlotCatalogFetchEpoch() !== epochAtFetchStart) {
        return res;
      }
      writeTowlotCatalogCacheFromResponse(res);
      dispatch(getTowlotCatalogRoutine.success(res));
      return res;
    })
    .catch((err) => {
      if (getTowlotCatalogFetchEpoch() !== epochAtFetchStart) {
        return;
      }
      dispatch(getTowlotCatalogRoutine.failure(err));
      throw err;
    })
    .finally(() => {
      loadTowlotCatalogPromise = null;
    });

  return loadTowlotCatalogPromise;
};
